/*
*   成功提示音
* */

export default class musicsConfig {
  constructor () {}

  /*
  *   订餐成功提示音
  * */

  static _playSuccessVoice(dom) {
    let $musicConfig = dom;
    $musicConfig.play();
  }

  /*
  *    点击提示音
  * */

  static _playClickVoice ( dom ) {
    let $musicConfig = dom;
    if($musicConfig) {
      $musicConfig.play();
    }

  }

  /*
  *    请选择菜品成功提示音
  * */

  static _playPleaseFoodVoice ( dom ) {
    let $musicConfig = dom;
    if ($musicConfig) {
      $musicConfig.play();
    }
  }

  /*
  *    谢谢提示音
  * */

  static _playThanksVoice ( dom ) {
    let $musicConfig = dom;
    if($musicConfig) {
      $musicConfig.play();
    }

  }
}






// WEBPACK FOOTER //
// ./src/utils/musicConfig.js